// extracted by mini-css-extract-plugin
export default {"popEditWrap":"popEditWrap___AD2Az","addIcon":"addIcon___u1Axb"};